import React from "react";

import { Auth } from "./useAuth";

export const AuthContext = React.createContext<Auth>({
  isAuthSession: false,
  sessionId: null,
  correlationId: null,
  serviceBaseUrl: null,
  launchSource: null,
  tenantId: null,
});
